//it is combined with reducer, initial state, and Notification components.
import { createNotificationAction } from './actions';
import Notifications from './Notifications';

export {
    createNotificationAction,
    Notifications
};

    